// Generated by purs version 0.13.0
"use strict";
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var removeItemFromInventory = function (item) {
    var takeItem = function (v) {
        if (v instanceof Data_Maybe.Just && v.value0 === 1) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Data_Maybe.Just) {
            return new Data_Maybe.Just(v.value0 - 1 | 0);
        };
        throw new Error("Failed pattern match at Ritoppu.Mutation.Inventory (line 19, column 14 - line 22, column 27): " + [ v.constructor.name ]);
    };
    return Data_Map_Internal.alter(Ritoppu_Model_Item.ordItem)(takeItem)(item);
};
var addItemToInventory = function (item) {
    return Data_Map_Internal.alter(Ritoppu_Model_Item.ordItem)((function () {
        var $4 = Data_Maybe.maybe(1)(Data_Semiring.add(Data_Semiring.semiringInt)(1));
        return function ($5) {
            return Data_Maybe.Just.create($4($5));
        };
    })())(item);
};
module.exports = {
    addItemToInventory: addItemToInventory,
    removeItemFromInventory: removeItemFromInventory
};
